import React from 'react';
import {
    Form,
    FormGroup,
    Label,
    Input,
    TextArea,
    ButtonGroup,
    CancelButton,
    CreateButton
} from '../../styles/CreateWorkspaceModal.styles';

const WorkspaceForm = ({
    name,
    description,
    loading,
    onNameChange,
    onDescriptionChange,
    onSubmit,
    onClose,
    isEdit = false
}) => (
    <Form onSubmit={onSubmit}>
        <FormGroup>
            <Label htmlFor="name">Workspace Name</Label>
            <Input
                id="name"
                type="text"
                value={name}
                onChange={onNameChange}
                placeholder="Enter workspace name"
                required
                maxLength={100}
                autoFocus
            />
        </FormGroup>

        <FormGroup>
            <Label htmlFor="description">Description</Label>
            <TextArea
                id="description"
                value={description}
                onChange={onDescriptionChange}
                placeholder="Add a description..."
                maxLength={500}
            />
        </FormGroup>

        <ButtonGroup>
            <CancelButton type="button" onClick={onClose}>
                Cancel
            </CancelButton>
            <CreateButton
                type="submit"
                disabled={loading || !name.trim()}
            >
                {loading ? 'Editing...' : isEdit ? 'Edit Workspace' : 'Create Workspace'}
            </CreateButton>
        </ButtonGroup>
    </Form>
);

export default WorkspaceForm;